import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, GraduationCap, Heart, CheckCircle, Clock, MapPin, ExternalLink, Mail, Phone, Users, Calendar, Award, Snowflake } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SEO } from '../components/SEO';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const SignupUrl = 'https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-6-12-ar-202627-374765';

export const BarneakademiPage = () => {
  useTranslation();
  return (
    <div data-testid="barneakademi-page" className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <SEO
        title={t('pg.BarneakademiPage.654a3b')}
        description={t('pg.BarneakademiPage.063d1d')}
      />
      <div className="max-w-4xl mx-auto">
        <Link to="/soccer" className="inline-flex items-center gap-2 text-slate-500 hover:text-green-500 transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" />
          {t('pg.BarneakademiPage.1cfcac')}
        </Link>

        {/* Hero */}
        <div className="bg-gradient-to-r from-green-500/20 to-transparent rounded-2xl p-8 border border-green-500/30 mb-8">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 bg-green-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <GraduationCap className="w-8 h-8 text-green-500" />
            </div>
            <div>
              <p className="text-green-500 font-medium uppercase tracking-widest text-xs mb-1">{t('pg.BarneakademiPage.ee088d')}</p>
              <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-3">{t('pg.BarneakademiPage.d5dd7d')}</h1>
              <p className="text-lg text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.d44684')} <strong className="text-green-500">{t('pg.BarneakademiPage.002fb6')}</strong>.
              </p>
            </div>
          </div>
        </div>

        {/* Hvorfor velge */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">{t('pg.BarneakademiPage.23ff09')}</h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                <Heart className="w-5 h-5 text-green-500" /> {t('pg.BarneakademiPage.4bd07b')}
              </h3>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.12eca0')}
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.9857a2')}</h3>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.26c6af')}
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.1bb9e8')}</h3>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.df9eef')}
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                <Award className="w-5 h-5 text-green-500" /> {t('pg.BarneakademiPage.f01530')}
              </h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">
                {t('pg.BarneakademiPage.c81aa8')}
              </p>
              <ul className="space-y-2 mb-3">
                {['Firehjørne-modellen', t('pg.BarneakademiPage.7d289f'), t('pg.BarneakademiPage.7fc6a9')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-slate-600 dark:text-slate-300 mb-3">
                {t('pg.BarneakademiPage.f21a77')}
              </p>
              <p className="text-slate-600 dark:text-slate-300 mb-3">
                {t('pg.BarneakademiPage.9bb41e')}
              </p>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.a48f64')}
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.f26831')}</h3>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.BarneakademiPage.26ad82')}
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.6e4202')}</h3>
              <p className="text-2xl font-bold text-green-500">{t('pg.BarneakademiPage.713ada')}</p>
              <p className="text-slate-500 dark:text-slate-400 text-sm">{t('pg.BarneakademiPage.aadfd6')}</p>
            </div>
          </div>
        </section>

        {/* Slik fungerer akademiet */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-2">
            <Clock className="w-6 h-6 text-green-500" /> {t('pg.BarneakademiPage.d2aafa')}
          </h2>

          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.1faeb0')}</h3>
          <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.BarneakademiPage.cfa672')}</p>
          <ul className="space-y-2 mb-6">
            {[t('pg.BarneakademiPage.53ddf7'), t('pg.BarneakademiPage.b883dc')].map(item => (
              <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                <Calendar className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneakademiPage.68c749')}</h3>
          <ul className="space-y-2">
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Calendar className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span><strong>{t('pg.BarneakademiPage.d32f0f')}</strong> {t('pg.BarneakademiPage.6f6d35')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Clock className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.BarneakademiPage.a06d65')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Users className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.BarneakademiPage.9d4ccd')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <MapPin className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.BarneakademiPage.4d3b9e')}</span>
            </li>
          </ul>
        </section>

        {/* Organisering */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.BarneakademiPage.01ab9e')}</h2>
          <p className="text-slate-600 dark:text-slate-300 mb-4">
            {t('pg.BarneakademiPage.252db6')}
          </p>
          <p className="text-slate-600 dark:text-slate-300 mb-2 font-medium">{t('pg.BarneakademiPage.3687cb')}</p>
          <ul className="space-y-2 mb-5">
            {[t('pg.BarneakademiPage.7480aa'), t('pg.BarneakademiPage.74a76f')].map(item => (
              <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <p className="text-slate-600 dark:text-slate-300 mb-2 font-medium">{t('pg.BarneakademiPage.7b68d7')}</p>
          <ul className="space-y-2 mb-5">
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Users className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.BarneakademiPage.779eb4')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Users className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.BarneakademiPage.3c8684')}</span>
            </li>
          </ul>

          <p className="text-slate-600 dark:text-slate-300 mb-2 font-medium">{t('pg.BarneakademiPage.a218ef')}</p>
          <ul className="space-y-2 mb-4">
            {[
              t('pg.BarneakademiPage.f9ebc1'),
              t('pg.BarneakademiPage.7d827e'),
              t('pg.BarneakademiPage.b47634'),
              t('pg.BarneakademiPage.453870'),
            ].map(item => (
              <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <p className="text-slate-600 dark:text-slate-300 italic">
            {t('pg.BarneakademiPage.a5a28c')}
          </p>
        </section>

        {/* Vintertrening */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center gap-2">
            <Snowflake className="w-6 h-6 text-green-500" /> {t('pg.BarneakademiPage.641cd2')}
          </h2>
          <p className="text-slate-600 dark:text-slate-300 mb-3">
            {t('pg.BarneakademiPage.1fe129')} <strong>{t('pg.BarneakademiPage.054168')}</strong>.
          </p>
          <p className="text-slate-600 dark:text-slate-300">
            {t('pg.BarneakademiPage.e087e6')}
          </p>
        </section>

        {/* Praktisk info */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.BarneakademiPage.68c749')}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.BarneakademiPage.62f536')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">3 000 kr</p>
              <p className="text-xs text-slate-400 dark:text-slate-500">{t('pg.BarneakademiPage.dc2883')}</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.BarneakademiPage.ac50c4')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">Ca. 80</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.BarneakademiPage.8fc494')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">{t('pg.BarneakademiPage.6f6d35')}</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.BarneakademiPage.7480aa')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">{t('pg.BarneakademiPage.ee088d')}</p>
            </div>
          </div>
        </section>

        {/* Signup CTA */}
        <section className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-8 mb-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">{t('pg.BarneakademiPage.309293')}</h2>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            {t('pg.BarneakademiPage.562545')}
          </p>
          <a href={SignupUrl} target="_blank" rel="noopener noreferrer" data-testid="barneakademi-signup">
            <Button size="lg" className="bg-white text-green-700 hover:bg-slate-100 font-bold text-base px-8 py-6">
              {t('pg.BarneakademiPage.740798')}
              <ExternalLink className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </section>

        {/* Kontakt */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.BarneakademiPage.8d1c6b')}</h2>
          <div className="space-y-2">
            <a href="mailto:fotballakademi@veitvet-sportsklubb.no" className="flex items-center gap-2 text-green-500 hover:underline">
              <Mail className="w-5 h-5" />
              fotballakademi@veitvet-sportsklubb.no
            </a>
            <a href="tel:+4790083520" className="flex items-center gap-2 text-green-500 hover:underline">
              <Phone className="w-5 h-5" />
              900 83 520
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BarneakademiPage;
